<template>
    <el-menu :default-active="route.path" class="menu" background-color="#d9ecff" text-color="#1f2d3d"
        active-text-color="#409EFF" router :collapse="isCollapse" unique-opened>
        <div class="logo">
            <img class="filterWrite" src="/src/assets/image/logo.png" />
        </div>
        <div class="userBox">
            <div class="avatar"></div>
        </div>
        <template v-for="(menuItem, index) in menu" :key="index">
            <el-sub-menu v-if="menuItem.children?.length" :index="`${index}`">

                <template #title>
                    <el-icon>
                        <component :is="menuItem.meta.icon || 'House'"></component>
                    </el-icon>
                    <span>{{ menuItem.meta?.title || menuItem.name }}</span>
                </template>
                <el-menu-item-group style="background: #c6e2ff;">
                    <el-menu-item v-for="(subItem, subIndex) in menuItem.children" :key="subIndex"
                        :index="fullPath(menuItem.path, subItem.path)">
                        <el-icon>
                            <component :is="subItem.meta?.icon || 'House'"></component>
                        </el-icon>
                        <template #title>{{ subItem.meta?.title || subItem.name }}</template>
                    </el-menu-item>
                </el-menu-item-group>
            </el-sub-menu>
            <el-menu-item v-else :index="fullPath(menuItem.path)">
                <el-icon>
                    <component :is="menuItem.meta?.icon || 'House'"></component>
                </el-icon>
                <template #title>{{ menuItem.meta?.title || menuItem.name }}</template>
            </el-menu-item>
        </template>
    </el-menu>
</template>

<script setup>
import { useUserStore } from '@/stores/user';
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';



const props = defineProps({
    isCollapse: {
        type: Boolean,
        default: false,
    },
});

const userStore = useUserStore()




const baseUrl = ref('/');
const menu = ref([]);

const fullPath = (parent = '', child = '') => {
    const a = String(baseUrl.value || '/');
    const b = String(parent || '');
    const c = String(child || '');
    const join = (...parts) => {
        const path =
            parts
                .map((p, i) => (i === 0 ? p.replace(/\/$/, '') : p.replace(/^\//, '')))
                .filter(Boolean)
                .join('/') || '/';
        return path.startsWith('/') ? path : `/${path}`;
    };
    return join(a, b, c);
};

const router = useRouter();
const route = useRoute();

const initMenu = () => {
    const routes = userStore.info.routers?.split(',')
    const routesArr = router.options.routes;
    const root = routesArr.find((r) => r.path === baseUrl.value);
    let children = root && Array.isArray(root.children) ? root.children : [];
    if (userStore.info.role != 0) {
        // children = children.filter((item) => routes.includes(item.name)).map(route => {
        //     if (route.children?.length) {
        //         route.children = route.children.filter(item => routes.includes(item.name))
        //         return route
        //     }
        //     return route
        // })
        children = children.filter((item) => {
            
            
            const showChildren = item.children?.filter(item => routes.includes(item.name))
            let show = routes.includes(item.name) || showChildren.length
            return show
        }).map(route => {
            if (route.children?.length) {
                route.children = route.children.filter(item => routes.includes(item.name))
                return route
            }
            return route

        })
    }

    menu.value.splice(0, menu.value.length, ...children);
};
initMenu();
watch(
  () => [userStore.info.uid, userStore.info.routers],
  () => {
    initMenu();
  },
  { deep: true }
);

</script>

<style lang="less" scoped>
.logo {
    padding: 20px;
    display: flex;
    justify-content: center;


    img {
        width: 80%;
    }
}



:deep(.el-menu-item.is-active) {
    border-right: 4px solid #409EFF;
}

.el-menu-item-group {
    padding: 10px 0;

    :deep(.el-menu-item-group__title) {
        display: none;
    }

}
</style>
